export const TYPE_FORM_EVENTS = {
  VIEW_REQUEST_ADDRESS_CHANGE_FORM: 'view_request_address_change_form',
  SELECT_CLOSE_ON_ADDRESS_CHANGE_FORM: 'select_close_on_address_change_form',
  SELECT_SUBMIT_ON_ADDRESS_CHANGE_FORM: 'select_submit_on_address_change_form',
} as const;
